<template>
  <div v-if="showContent" class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/dashboard/">
        <img
          class="navbar-brand-full"
          src="/img/brand/logo2.png"
          width="90"
          height="35"
          alt="CoreUI Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="/img/brand/part.png"
          width="20"
          height="20"
          alt="Fiber Node Services"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-navbar-nav class="d-md-down-none"> </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none"> </b-nav-item>
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav style="width: 230px" :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div style="padding-top: 17px" class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <div></div>
      <div class="ml-auto">
        <a href="https://www.fibernode.com/main/">Fiber Node Services Inc.</a>
        <span class="ml-1">&copy; 2021</span>
      </div>
    </TheFooter>
  </div>
  <div
    v-else
    style="display: flex; justify-content: center; align-items: center;"
  >
    <div class="sk-double-bounce bouncing2">
      <div class="sk-child sk-double-bounce1"></div>
      <div class="sk-child sk-double-bounce2"></div>
    </div>
  </div>
</template>

<script>
import {
  Aside as AppAside,
  Header as AppHeader,
  Sidebar as AppSidebar,
  AsideToggler,
  Breadcrumb,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  SidebarToggler,
  Footer as TheFooter
} from "@coreui/vue";
import mainNav from "../navigation/mainNav";
import router from "../router";
import { userTabs } from "../shared/utils";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  methods: {
    choosePaths(userAccess) {
      let navArray = [];
      if (localStorage.getItem("fns_user")) {
        for (const [key, value] of Object.entries(userAccess)) {
          if (value) {
            navArray.push(...mainNav[key].nav);
          }
        }
      }
      return navArray;
    }
  },
  data() {
    return {
      userAccess: {
        GENERAL: true,
        TECH_STAT: true,
        SALES: true,
        ISSUES: true,
        FNS: true,
        ACC_REC: true
      },
      showContent: false,
      nav: [],
      full_name: ""
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  },
  beforeMount() {
    let allowedTabs = userTabs(JSON.parse(localStorage.getItem("user_tabs")));
    this.nav = this.choosePaths(allowedTabs);
  },
  mounted() {
    let path = localStorage.getItem("redirect_path");
    if (path) {
      this.showContent = true;
    } else {
      router.replace("/pages/login");
    }
    this.full_name = localStorage.getItem("fns_full_name");
  }
};
</script>

<style>
.sidebar .nav {
  width: 225px;
}
html:not([dir="rtl"]) .sidebar {
  margin-left: -225px;
}
@media (min-width: 992px) {
  .sidebar-minimized .sidebar .sidebar-nav {
    overflow: visible;
    width: 50px !important;
  }
}
</style>
